import { useQueryParamContext, useTimeFilterContext } from 'modules/iterableGoals/contexts';
import { fetchGoalAnalyticsRequest } from 'modules/iterableGoals/ducks/actions';
import { OverviewSectionType, OverviewTabSection } from 'modules/iterableGoals/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  CampaignPerformance,
  CompletionVsSends,
  GoalContributionsByMedium,
  GoalPerformance,
} from '../sections';
import {
  CampaignPerformanceWrapper,
  CompletionVsSendsWrapper,
  GoalContributionsByMediumWrapper,
  GoalPerformanceWrapper,
  OverviewTabWrapper,
} from './Styled';
import { TabSections } from './TabSections';

const overviewSections: OverviewSectionType[] = [
  {
    SectionWrapper: GoalPerformanceWrapper,
    SectionComponent: GoalPerformance,
    section: OverviewTabSection.GOAL_PERFORMANCE,
  },
  {
    SectionWrapper: CompletionVsSendsWrapper,
    SectionComponent: CompletionVsSends,
    section: OverviewTabSection.COMPLETION_VS_SENDS,
  },
  {
    SectionWrapper: GoalContributionsByMediumWrapper,
    SectionComponent: GoalContributionsByMedium,
    section: OverviewTabSection.GOAL_CONTRIBUTIONS_BY_MEDIUM,
  },
  {
    SectionWrapper: CampaignPerformanceWrapper,
    SectionComponent: CampaignPerformance,
    section: OverviewTabSection.CAMPAIGN_PERFORMANCE,
  },
];

export const OverviewTab = () => {
  const dispatch = useDispatch();
  const { goalName, includeRevenue, includePrevious } = useQueryParamContext();
  const {
    timeParams: { startTime, endTime },
  } = useTimeFilterContext();

  /**
   * Since, the data for the first 3 cards on this tab is coming from the same endpoint.
   * We are just going to do the fetch for the data here and pass it down the tab.
   */
  const fetchGoalAnalyticsData = (
    goalIdentifier?: string,
    analyticsStartTime?: string,
    analyticsEndTime?: string,
  ) => {
    if (!goalIdentifier || !analyticsStartTime || !analyticsEndTime) return;

    dispatch(
      fetchGoalAnalyticsRequest({
        includeRevenue,
        includePrevious,
        conversionEvent: goalIdentifier,
        startTime: analyticsStartTime,
        endTime: analyticsEndTime,
      }),
    );
  };

  /**
   * Fetch new performant campaign data as required
   */
  useEffect(() => {
    fetchGoalAnalyticsData(goalName, startTime, endTime);
  }, [goalName, startTime, endTime]);

  return (
    <OverviewTabWrapper data-test="goal-analytics-overview-tab-content">
      <TabSections
        tabSectionList={overviewSections}
        reFetchGoalAnalyticsData={() => fetchGoalAnalyticsData(goalName, startTime, endTime)}
      />
    </OverviewTabWrapper>
  );
};
